import { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DropdownWithLabel } from '@blueprint/dropdown';
import { FiltersLabel } from '../../../search/FiltersModal/Filters.styles';
import {
    DropdownWrapper,
    RightWrapper,
    LeftWrapper
} from '../../../search/common/Dropdown.styles';
import {
    SelectBedsMinOptions,
    SelectBedsMaxOptions
} from '../../../search/common/SelectBedsOptions';
import {
    updateFilter,
    bedsMinSelector,
    bedsMaxSelector
} from '../../../reducers/filters';
import { FilterWrapper } from './SearchInitiationMobileModal.styles';

export const SelectBeds = () => {
    const reduxDispatch = useDispatch();
    const { selectedValue: bedsMinSelectedValue, options: bedsMinOptions } =
        useSelector(bedsMinSelector);
    const { selectedValue: bedsMaxSelectedValue, options: bedsMaxOptions } =
        useSelector(bedsMaxSelector);

    const onMaxBedsChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        const {
            currentTarget: { value }
        } = evt;

        reduxDispatch(updateFilter('maxBedrooms', value));
    };

    const onMinBedsChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        const {
            currentTarget: { value }
        } = evt;

        reduxDispatch(updateFilter('minBedrooms', value));
    };

    const bedsMinInt = parseInt(bedsMinSelectedValue, 10);
    const bedsMaxInt = parseInt(bedsMaxSelectedValue, 10);

    const bedroomsLabel = 'Bedrooms';
    const minBedsLabel = 'Min beds';
    const bedsOptionsLabel = 'Any beds';
    const maxBedsLabel = 'Max beds';

    return (
        <FilterWrapper>
            <FiltersLabel htmlFor="modal-beds-filter">
                {bedroomsLabel}
            </FiltersLabel>
            <DropdownWrapper>
                <LeftWrapper>
                    <DropdownWithLabel
                        id="mobile_beds_min"
                        onChange={onMinBedsChange}
                        value={bedsMinSelectedValue}
                        name="beds_min"
                        aria-label="Min Beds"
                        data-testid="min_beds_mobile"
                        label={minBedsLabel}
                        hasBorderRadius
                    >
                        {bedsMinOptions ? (
                            <SelectBedsMinOptions
                                bedsOtherInt={bedsMaxInt}
                                options={bedsMinOptions}
                                keyPrefix="modal-min-beds"
                            />
                        ) : (
                            <option>{bedsOptionsLabel}</option>
                        )}
                    </DropdownWithLabel>
                </LeftWrapper>
                <RightWrapper>
                    <DropdownWithLabel
                        onChange={onMaxBedsChange}
                        value={bedsMaxSelectedValue}
                        id="beds_max"
                        name="beds_max"
                        aria-label="Max Beds"
                        data-testid="max_beds_mobile"
                        label={maxBedsLabel}
                        hasBorderRadius
                    >
                        {bedsMaxOptions ? (
                            <SelectBedsMaxOptions
                                bedsOtherInt={bedsMinInt}
                                options={bedsMaxOptions}
                                keyPrefix="modal-max-beds"
                            />
                        ) : (
                            <option>{bedsOptionsLabel}</option>
                        )}
                    </DropdownWithLabel>
                </RightWrapper>
            </DropdownWrapper>
        </FilterWrapper>
    );
};
